export default {
  render: function render(self) {
    var _self$params = self.params,
        sliderLabel = _self$params.sliderLabel,
        sliderValue = _self$params.sliderValue,
        sliderValueEditable = _self$params.sliderValueEditable,
        hueLabelText = _self$params.hueLabelText;
    return "\n      <div class=\"color-picker-module color-picker-module-hue-slider\">\n        <div class=\"color-picker-slider-wrap\">\n          ".concat(sliderLabel ? "\n            <div class=\"color-picker-slider-label\">".concat(hueLabelText, "</div>\n          ") : '', "\n          <div class=\"range-slider color-picker-slider color-picker-slider-hue\"></div>\n          ").concat(sliderValue ? "\n            <div class=\"color-picker-slider-value\">\n              ".concat(sliderValueEditable ? "\n                <input type=\"number\" step=\"0.1\" min=\"0\" max=\"360\" class=\"color-picker-value-hue\">\n              " : "\n                <span class=\"color-picker-value-hue\"></span>\n              ", "\n            </div>\n          ") : '', "\n        </div>\n      </div>\n    ");
  },
  init: function init(self) {
    self.hueRangeSlider = self.app.range.create({
      el: self.$el.find('.color-picker-slider-hue'),
      min: 0,
      max: 360,
      step: 0.1,
      value: 0,
      on: {
        change: function change(range, value) {
          self.setValue({
            hue: value
          });
        }
      }
    });
  },
  update: function update(self) {
    var value = self.value;
    var _self$params2 = self.params,
        sliderValue = _self$params2.sliderValue,
        sliderValueEditable = _self$params2.sliderValueEditable;
    var hue = value.hue;
    self.hueRangeSlider.value = hue;
    self.hueRangeSlider.layout();
    self.hueRangeSlider.$el[0].style.setProperty('--f7-range-knob-color', "hsl(".concat(hue, ", 100%, 50%)"));

    if (sliderValue && sliderValueEditable) {
      self.$el.find('input.color-picker-value-hue').val("".concat(hue));
    } else if (sliderValue) {
      self.$el.find('span.color-picker-value-hue').text("".concat(hue));
    }
  },
  destroy: function destroy(self) {
    if (self.hueRangeSlider && self.hueRangeSlider.destroy) {
      self.hueRangeSlider.destroy();
    }

    delete self.hueRangeSlider;
  }
};